







import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BaseButtonRefresh extends Vue {
  @Prop({ required: true })
  action!: string;

  @Prop({ required: true })
  context!: string;

  title = "Refresh";

  tooltipTitle = `Refresh ${this.context}`;

  isRefreshing = false;

  refresh() {
    this.title = "Refreshing";
    this.isRefreshing = true;
    this.$ga.button(this.tooltipTitle);
    const invalidate = true;
    this.$store.dispatch(this.action, invalidate).then(() => {
      this.title = "Refreshed!";
      this.isRefreshing = false;
      setTimeout(() => {
        this.title = "Refresh";
      }, 1000);
    });
  }
}
